import { makeStyles, Theme } from "@material-ui/core";
import { Formik } from "formik";
import React, { ReactNode, useCallback } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { FormikTextField } from "../../../components/form/Formik";
import FormError from "../../../components/form/Formik/FormError";
import { useRecaptchaFormikForm } from "../../../components/form/Formik/hooks/useRecaptchaFormikForm";
import { RecaptchaSubmitButton } from "../../../components/form/Formik/RecaptchaSubmitButton";
import { getSignUpUrl } from "../../../utils/hubRoutes";
import { Layout } from "../../components/Layout";
import { PageHelmet } from "../../components/PageHelmet";
import { useRecoveryPage } from "./useRecoveryPage";

const useStyles = makeStyles(
  (theme: Theme) => ({
    form: {
      display: "flex",
      flexDirection: "column",
    },
    button: {
      alignSelf: "center",
      marginTop: 10,
      [theme.breakpoints.up("xs")]: {
        marginTop: 6,
      },
    },
    notice: {
      marginTop: 24,
      textAlign: "center",
      fontSize: 12,
      fontWeight: 500,
      [theme.breakpoints.up("xs")]: {
        marginTop: 20,
        "& span": {
          display: "block",
        },
      },
      "& a": {
        color: "inherit",
        fontWeight: 600,
        fontSize: 11,
      },
    },
    linkBlock: {
      textAlign: "center",
      marginTop: 24,
      fontWeight: 700,
    },
    signUpLink: {
      marginLeft: 6,
      fontWeight: 600,
    },
  }),
  { name: "RecoveryPage" }
);

export const RecoveryPage = () => {
  const { initialValues, validationSchema, onSubmit, locale } = useRecoveryPage();
  const { formatMessage } = useIntl();
  const { recaptchaButtonRef, onKeyPress } = useRecaptchaFormikForm();
  const classes = useStyles();
  const label = formatMessage({ id: "common.email" });

  const link = useCallback((chunks: ReactNode) => <Link to={`/${locale}/login-email`}>{chunks}</Link>, [locale]);

  return (
    <Layout
      title={formatMessage({ id: "recovery.forgotPassword" })}
      subTitle={formatMessage({ id: "recovery.subTitle" })}
    >
      <PageHelmet path="recovery" />
      <Formik onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema}>
        <div className={classes.form} onKeyPress={onKeyPress}>
          <FormikTextField fullWidth name="email" placeholder={label} />
          <FormError />
          <RecaptchaSubmitButton className={classes.button} ref={recaptchaButtonRef}>
            <FormattedMessage id="common.continue" />
          </RecaptchaSubmitButton>
          <div className={classes.notice}>
            <FormattedMessage id="recovery.emailNotice1" />
            <span> </span>
            <FormattedMessage id="recovery.emailNotice2" values={{ link }} />
          </div>
          <div className={classes.linkBlock}>
            <FormattedMessage id="login.noAccount" />
            <a href={getSignUpUrl(locale)} className={classes.signUpLink}>
              <FormattedMessage id="login.create" />
            </a>
          </div>
        </div>
      </Formik>
    </Layout>
  );
};
